import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

export default class LastAvailableCell extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;

    return (
      <td {...this.props.tdProps}>
        {this.props.dataItem.LastAvailable !== null ? Math.trunc(this.props.dataItem.LastAvailable) : '-'}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
  }
}